import React, { useEffect, useRef, useState } from "react";
import { useAllProgramsQuery, useSearchByValuesLazyQuery } from "hooks/graphql";
import { AdvancedSearch as AdvancedSearchComponent } from "components/AdvancedSearch";
import { IndividualType } from "types/globalTypes";

interface AdvancedSearchProps {
  routeMemberPage: (id: string) => void;
  routeProspectPage: (id: string) => void;
}

export const AdvancedSearch: React.FC<AdvancedSearchProps> = ({
  routeMemberPage,
  routeProspectPage,
}) => {
  const [showNoResults, setNoResults] = useState(false);
  const [
    searchByValues,
    {
      data: { searchByValues: { results = [] } = {} } = {},
      loading = false,
    } = {},
  ] = useSearchByValuesLazyQuery({
    fetchPolicy: "network-only",
  });

  const {
    data: { allPrograms: { nodes = [] } = {} } = {},
    loading: programCodesLoading,
  } = useAllProgramsQuery();

  const initialRender = useRef(true);
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }
    setNoResults(results.length === 0);
  });
  return (
    <AdvancedSearchComponent
      search={(searchValues) => {
        searchByValues({ variables: { input: searchValues } });
      }}
      loading={loading}
      showWarningMessage={showNoResults}
      programCodesLoading={programCodesLoading}
      programCodeOptions={nodes.map((code) => ({
        value: code.programCode,
        title: code.programCode,
      }))}
      results={
        results.length > 0
          ? results.map(
              ({
                id,
                shortId,
                names,
                birthDate,
                programCode,
                status,
                externalId,
                individualType,
                phoneNumbers,
              }) => ({
                id,
                firstName: names.length > 0 ? names[0].firstName : "-",
                lastName: names.length > 0 ? names[0].lastName : "-",
                birthDate,
                programCode,
                status,
                shortId,
                externalId,
                individualType,
                phoneNumber:
                  phoneNumbers.length > 0 ? phoneNumbers[0].phoneNumber : "-",
              }),
            )
          : []
      }
      routeSearchResult={({ contactType, id }) => {
        switch (contactType) {
          case IndividualType.Member:
            routeMemberPage(id);
            break;
          case IndividualType.Prospect:
            routeProspectPage(id);
            break;
          default:
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            throw new Error(`Invalid IndividualType provided: ${contactType}`);
        }
      }}
    />
  );
};

export default AdvancedSearch;
